<!--
Copyright 2021 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
-->

@if (!!data && data.scenario !== undefined && data.scenario !== null) {
  <div
    mat-dialog-content
    >
    <div class="add-margin">
      <div>
        <mat-form-field class="full-width">
          <mat-label>Name (required)</mat-label>
          <input
            type="text"
            matInput
            [formControl]="scenarioNameFormControl"
            placeholder="Name (required)"
            (blur)="saveScenario('name')"
            value="{{ data.scenario.name }}"
            [errorStateMatcher]="matcher"
            />
          @if (
            scenarioNameFormControl.hasError('minlength') &&
            !scenarioNameFormControl.hasError('required')
            ) {
            <mat-error
              >
              Must contain 4 or more characters
            </mat-error>
          }
          @if (scenarioNameFormControl.hasError('required')) {
            <mat-error>
              Name is <strong>required</strong>
            </mat-error>
          }
        </mat-form-field>
      </div>
    </div>
    <div class="add-margin">
      <div>
        <mat-form-field class="full-width">
          <mat-label>Scenario Description (required)</mat-label>
          <textarea
            matInput
            placeholder="Scenario Description (required)"
            [formControl]="descriptionFormControl"
            (blur)="saveScenario('description')"
            value="{{ data.scenario.description }}"
            [errorStateMatcher]="matcher"
          ></textarea>
          @if (descriptionFormControl.hasError('required')) {
            <mat-error>
              Description is <strong>required</strong>
            </mat-error>
          }
        </mat-form-field>
      </div>
    </div>
    <div class="add-margin">
      <div>
        <mat-form-field>
          <mat-label>View</mat-label>
          <mat-select
            placeholder="View"
            [(ngModel)]="data.scenario.viewId"
            (selectionChange)="saveScenario('view')"
            >
            <mat-option>None</mat-option>
            @for (view of data.views; track view) {
              <mat-option
                [value]="view.id"
                [matTooltip]="view.id"
                matTooltipPosition="right"
                >
                {{ view.name }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div class="add-margin">
      <div>
        <mat-form-field>
          <mat-label>Start Date / Time</mat-label>
          <input
            matInput
            [ngxMatDatetimePicker]="startDatePicker"
            [formControl]="startDateFormControl"
            (dateChange)="saveScenario('startDate')"
            style="display: none;"
            >
          <span (click)="startDatePicker.open()" style="cursor: pointer;">
            {{ startDateFormControl.value | date: 'dd MMM yyyy HH:mm:ss' }}
          </span>
          <ngx-mat-datepicker-toggle matSuffix [for]="startDatePicker">
          </ngx-mat-datepicker-toggle>
          <ngx-mat-datetime-picker #startDatePicker
            [showSpinners]="true"
            [showSeconds]="true"
            [stepHour]="1"
            [stepMinute]="1"
            [stepSecond]="1"
            [touchUi]="false"
            [enableMeridian]="true"
            [disableMinute]="false"
            [hideTime]="false">
            <ngx-mat-datepicker-actions>
              <button mat-stroked-button ngxMatDatepickerApply>Save</button>
              <button mat-stroked-button ngxMatDatepickerCancel>Cancel</button>
            </ngx-mat-datepicker-actions>
          </ngx-mat-datetime-picker>
        </mat-form-field>
      </div>
    </div>
    <div class="add-margin">
      <div>
        <mat-form-field>
          <mat-label>End Date / Time</mat-label>
          <input
            matInput
            [ngxMatDatetimePicker]="endDatePicker"
            [formControl]="endDateFormControl"
            (dateChange)="saveScenario('endDate')"
            style="display: none;"
            >
          <span (click)="endDatePicker.open()" style="cursor: pointer;">
            {{ endDateFormControl.value | date: 'dd MMM yyyy HH:mm:ss' }}
          </span>
          <ngx-mat-datepicker-toggle matSuffix [for]="endDatePicker">
          </ngx-mat-datepicker-toggle>
          <ngx-mat-datetime-picker #endDatePicker
            [showSpinners]="true"
            [showSeconds]="true"
            [stepHour]="1"
            [stepMinute]="1"
            [stepSecond]="1"
            [touchUi]="false"
            [enableMeridian]="true"
            [disableMinute]="false"
            [hideTime]="false">
            <ngx-mat-datepicker-actions>
              <button mat-stroked-button ngxMatDatepickerApply>Save</button>
              <button mat-stroked-button ngxMatDatepickerCancel>Cancel</button>
            </ngx-mat-datepicker-actions>
          </ngx-mat-datetime-picker>
        </mat-form-field>
      </div>
    </div>
    <div class="cssLayoutRowStartCenter bottom-button">
      <div class="delete-button">
        <button
          mat-stroked-button
          (click)="handleEditComplete(true)"
          [disabled]="!errorFree()"
          style="margin-left: 40px"
          >
          Save
        </button>
      </div>
      <div class="delete-button">
        <button mat-stroked-button (click)="handleEditComplete(false)">
          Cancel
        </button>
      </div>
    </div>
  </div>
}
